export default __webpack_public_path__ + "static/media/hht2_ep19_speaking_03.4c0c2bea.png";